import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CountryEnv } from '../models/CountryEnv';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class eGain {
  private eglvchathandle = null;
  private egainUrl = null;
  private eGainData = {
    EGAIN_SERVICE_TEMPLATE:
      '/system/templates/chat/countryclicktochatService/chat.html?entryPointId=1003&templateName=countryclicktochatService',
    EGAIN_SALES_TEMPLATE:
      '/system/templates/chat/countryclicktochatSales/chat.html?entryPointId=1002&templateName=countryclicktochatSales',
    EGAIN_PROD_URL: 'https://egain.countryfinancial.com',
    EGAIN_DEV_URL: 'https://egaindev.countryfinancial.net',
    EGAIN_WINDOW_PARAMS: 'height=623,width=419,resizable=yes,scrollbars=yes,toolbar=no',
  };

  constructor() {
    if (decodeURIComponent(this.getReferrerUrl()).includes('countryfinancial.com')) {
      this.egainUrl = this.eGainData.EGAIN_PROD_URL;
    } else {
      this.egainUrl = this.eGainData.EGAIN_DEV_URL;
    }
  }

  public clickToChat() {
    try {
      if (this.eglvchathandle !== null && this.eglvchathandle.closed === false) {
        this.eglvchathandle.focus();
        return;
      }
    } catch (err) {
      // shhh
    }

    let refererName = '';
    refererName = encodeURIComponent(refererName);
    let refererurl = this.getReferrerUrl();
    const hashIndex = refererurl.lastIndexOf('#');
    if (hashIndex !== -1) {
      refererurl = refererurl.substring(0, hashIndex);
    }
    const eglvcaseid = /eglvcaseid=[0-9]*/gi.exec(window.location.search);
    let vhtIds = '';
    if (typeof window['EGAINCLOUD'] !== 'undefined' && window['EGAINCLOUD'].Account.getAllIds) {
      const ids = window['EGAINCLOUD'].Account.getAllIds();
      vhtIds = `&aId=${ids.a}&sId=${ids.s}&uId=${ids.u}`;
    }
    const EG_CALL_Q = window['EG_CALL_Q'] || [];
    EG_CALL_Q.push(['enableTracker', true]);
    let templateName = this.eGainData.EGAIN_SERVICE_TEMPLATE;

    let eGainChatUrl = `${this.egainUrl}${templateName}&languageCode=en&countryCode=US&ver=v11&eglvrefname=${refererName}&${eglvcaseid}${vhtIds}`;
    if ((eGainChatUrl + refererurl).length <= 2000) {
      eGainChatUrl += `&referer=${refererurl}`;
    }
    this.eglvchathandle = window.open(eGainChatUrl, '', this.eGainData.EGAIN_WINDOW_PARAMS);
  }

  private getReferrerUrl(): string {
    const isNativeOrLocal = Capacitor.isNativePlatform() || window.location.protocol === 'capacitor:' || window.location.hostname === 'localhost';

    if (!isNativeOrLocal) {
      return encodeURIComponent(document.location.href);
    }
    
    let ENV_ORIGIN = environment.origin;

    const devEnvironmentString = localStorage.getItem('devEnvironmentObj');
    if (devEnvironmentString) {
      const devEnvironment: CountryEnv = JSON.parse(devEnvironmentString);
      ENV_ORIGIN = devEnvironment.origin;
    }

    return encodeURIComponent(ENV_ORIGIN + window.location.pathname + window.location.search);
  }
}
